import Staff from './index.vue';

export default [
  {
    path: '/staff-list',
    name: 'Staff',
    component: Staff,
    meta: {
      title: '员工管理'
    }
  }
];



// WEBPACK FOOTER //
// ./src/views/Staff/index.js